import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/global.css';

const Login = ({ setUser, theme, onToggleTheme }) => {
    const [credentials, setCredentials] = useState({ user: '', pass: '' });
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        try {
            const response = await fetch('https://cms.amservices.eu/api/auth/auth.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    // On map les champs du state React vers ce que PHP attend
                    login: credentials.user,
                    password: credentials.pass
                }),
                credentials: 'include'
            });
            const data = await response.json();

            if (data.success) {
                // Vérification de sécurité pour ne pas planter le JSON.parse plus tard
                if (data.user) {
                    console.log("Connexion réussie :", data.user);
                    localStorage.setItem('am_user', JSON.stringify(data.user));
                    localStorage.setItem('am_token', data.token || data.user.token || '');
                    setUser(data.user);
                    navigate('/home');
                } else {
                    setError('Erreur : Données utilisateur manquantes');
                }
            } else {
                setError(data.message || 'Identifiants incorrects');
            }
        } catch (err) {
            console.error(err);
            setError('Erreur de connexion au serveur');
        }
    };

    return (
        <div className="admin-page cms-login-page">
            <button
                type="button"
                className="cms-login-theme-toggle"
                onClick={onToggleTheme}
                aria-label={theme === 'light' ? 'Activer le mode sombre' : 'Activer le mode clair'}
                title={theme === 'light' ? 'Mode sombre' : 'Mode clair'}
            >
                <span aria-hidden="true">{theme === 'light' ? '☾' : '☀'}</span>
                {theme === 'light' ? 'Sombre' : 'Clair'}
            </button>
            <div className="stat-card cms-login-card">
                <h1>AM SERVICES</h1>
                <p className="stat-label">Connexion Admin</p>

                {error && <div className="ko-text cms-login-error">{error}</div>}

                <form onSubmit={handleSubmit} className="cms-login-form">
                    <input
                        type="text"
                        placeholder="Utilisateur"
                        className="btn cms-login-input"
                        value={credentials.user}
                        onChange={e => setCredentials({ ...credentials, user: e.target.value })}
                        required
                    />
                    <input
                        type="password"
                        placeholder="Mot de passe"
                        className="btn cms-login-input"
                        value={credentials.pass}
                        onChange={e => setCredentials({ ...credentials, pass: e.target.value })}
                        required
                    />
                    <button type="submit" className="btn btn-primary">Se connecter</button>
                </form>
            </div>
        </div>
    );
};

export default Login;
